<template>
    <div>
        <PaymentIframe v-model="iframePayment" :clientId="clientId"></PaymentIframe>
        <aside id="side-overlay" class="checkout-overlay" style="border-radius: 8px; padding: 12px" data-simplebar="init">
            <form :action="action" method="POST" ref="form">
                <OverlayBody>
                    <template #overlay-header>
                        <OverlayHeader
                            :routeCustomerFile="routeCustomerFile"
                            :currentCustomer="currentCustomer"
                            v-on:show-iframe="userId => redirect_userPayment(userId)"
                        ></OverlayHeader>
                    </template>

                    <template #card-component>
                        <cart-component
                            :accompte="accompte"
                            :rest="rest"
                            :totalAccompte="totalAccompte"
                            :totalWithDiscount="totalWithDiscount"
                            :cartTotal="cartTotal"
                            :promoCode="promoCode"
                            :saveBasketRoute="saveBasketRoute"
                            @submit-form="submit"
                            @used-fidelity-points="updateFidelityPoints"
                            :orderId="orderId"
                            :isClotured="isClotured"
                            :orderObj="orderObj"
                            :customerSocieties="customerSocieties"
                        ></cart-component>
                    </template>

                    <template #payment-component>
                        <payment-component
                            :customer="customer"
                            :promoCodes="promoCodes"
                            :promoCode="promoCode"
                            :paymentMethods="paymentMethods"
                            :usedFidelityPoints="usedFidelityPoints"
                            :cartTotal="cartTotal"
                            :rest="rest"
                            :accompte="accompte"
                            :currentOrder="c_order"
                            :promotions="promotions"
                            :userId="userId"
                            :orderId="orderId"
                        ></payment-component>
                    </template>

                    <template #voucher-tab>
                        <voucher-tab @vouchers-update="updateVoucherAmount"></voucher-tab>
                    </template>
                    <template #avoir-tab>
                        <avoir-tab @credits-update="updateCreditAmount"></avoir-tab>
                    </template>
                    <template #serie-treatment-tab>
                        <serie-treatment-tab></serie-treatment-tab>
                    </template>
                    <template #waiting-sales-tab>
                        <waiting-sales-tab :incompleted-orders="incompletedOrders"></waiting-sales-tab>
                    </template>
                </OverlayBody>
            </form>
        </aside>
    </div>
</template>

<script>
import PaymentIframe from '../../Calendar/Iframe/PaymentIframe'
import { sync, get } from 'vuex-pathify'
import InitManager from './_core/InitManager'
import ApiManager from './_core/ApiManager'
import OverlayHeader from './OverlayHeader.vue'
import OverlayBody from './OverlayBody.vue'
import CloseSaleModal from './CloseSaleModal.vue'
import axios from 'axios'

export default {
    components: { PaymentIframe, OverlayHeader, OverlayBody, CloseSaleModal },
    props: [
        'currentCustomer', // (type USER)
        'routeCustomerFile', // (Url profil client)

        'cartTotal', // Backet amount (computed by back)
        'paymentMethods', // List of payment methods (establishment)
        'promoCodes', // List of promoCode (establishment)

        'action', // (URL post formulaire)
        'rest', // (Already paid)
        'accompte', // accompte

        'cartItems', // (Basket list)
        'incompletedOrders', // (Basket sauvergarder client)
        'establishment', // (Etablissement)

        'saveBasketRoute', // (URL de sauvegarde de panier)

        'orderId', // Order Id
        'promotions',
        'userId',
        'isClotured',
        'orderObj',
        'customerSocieties'
    ],
    data: () => ({
        clientId: null,
        iframePayment: false,

        payments: [],

        totalPaid: 0,
        order: null,
        selectedPaymentMethods: [],

        // promo code
        selectCode: [],
        promoCode: null,
        promoCodeApplied: false,
        wrongPromoCode: null,

        totalWithDiscount: 0,
        clientId: null,
        totalDiscount: 0,

        // voucher
        voucherAmount: 0,
        customer: null,

        totalAccompte: 0.0,
        totalWRest: 0.0,

        //fidelity points
        usedFidelityPoints: 0,
        
        //avoir
        avoirAmount: 0,

        //treatments and series
        treatmentIndex: null,
        serieIndex: null,
        prepaidPrestations: [],

        //close sale
        closeSaleModal: false,
    }),
    async created() {
        this.c_overlay = InitManager.createInitialCheckoutOverlayState()
        this.c_customer = this.currentCustomer
        this.paymentMethods.forEach(e => {
            if (!e.name.includes('Abonnement') && !e.name.includes('Cure') && !e.name.includes('cadeau')) {
                this.c_payments.push({ name: e.name, value: 0, color: e.color })
            }
        })
        this.c_payments.push({ name: 'Remise personnalisée', value: 0, isRemisePersonalisee: true })
        this.c_establishment = this.establishment
        for (const key of Object.keys(this.cartItems)) {
            this.cartItems[key].seller = await axios
                .post('/back-office/user/get/user/by/array', { users: [this.cartItems[key].options.seller_id] })
                .then(res => {
                    const target = res?.data[0]
                    if (target) {
                        return {
                            id: target.id,
                            email: target.email,
                            first_name: target.first_name,
                            last_name: target.last_name,
                        }
                    }
                })
            this.cartItems[key].advised = await axios
                .post('/back-office/user/get/user/by/array', { users: [this.cartItems[key].options.advised_id] })
                .then(res => {
                    const target = res?.data[0]
                    if (target) {
                        return {
                            id: target.id,
                            email: target.email,
                            first_name: target.first_name,
                            last_name: target.last_name,
                        }
                    }
                })
        }
        const cards = this.cartItems
        for (const key in cards) {
            cards[key].code = null // observable
        }
        this.c_cartItems = cards

        if (
            this.c_cartItems[Object.keys(this.c_cartItems)[0]] &&
            this.c_cartItems[Object.keys(this.c_cartItems)[0]].options.order_id
        ) {
            await this.getOrder(this.c_cartItems[Object.keys(this.c_cartItems)[0]].options.order_id)
        } else if (
            this.c_cartItems[Object.keys(this.c_cartItems)[0]] &&
            this.c_cartItems[Object.keys(this.c_cartItems)[0]].options.booking_id
        ) {
            await this.getOrderByBookingId(this.c_cartItems[Object.keys(this.c_cartItems)[0]].options.booking_id)
        }

        // Load Promo Codes of booking
        if (this.c_order) {
            axios.get(`/back-office/promotion/get/code/orderid/${this.c_order.id}`).then(res => (

            this.c_tmpPromoCodes = res.data))
        }
    },
    async mounted() {
        this.totalWithDiscount = this.cartTotal
        this.cartRest = this.cartTotal
        this.totalWRest =
            this.cartTotal -
            this.rest -
            this.payments.reduce((previous, current) => parseFloat(previous, 10) + parseFloat(current || 0, 10), 0)
        this.checkPromoBefore()
        this.treatmentIndex = this.paymentMethods.findIndex(el => el.name.includes('Cure'))
        this.serieIndex = this.paymentMethods.findIndex(el => el.name.includes('Abonnement'))
        window.onload = window.customer = document.getElementById('customerSelect').value
        this.customer = window.customer
    },
    methods: {
        paymentAmountAppliedToOrder(payment) {
            if (
                payment?.is_prepaid_consumption
                && payment.amount_applied_to_order !== null
                && payment.amount_applied_to_order !== undefined
            ) {
                return parseFloat(payment.amount_applied_to_order || 0)
            }

            return parseFloat(payment?.amount || 0)
        },

        updateVoucherAmount(vouchersUsed) {
            if (vouchersUsed.length == 0) {
                this.voucherAmount = 0
            } else {
                this.voucherAmount = vouchersUsed.reduce((prev, cur) => prev + cur, 0)
            }
        },

        updateFidelityPoints(fidelityPoints) {
            this.usedFidelityPoints = fidelityPoints
        },

        updateCreditAmount(creditsUsed) {
            if (creditsUsed.length == 0) {
                this.avoirAmount = 0
            } else {
                this.avoirAmount = creditsUsed.reduce((prev, cur) => prev + cur, 0)
            }
        },

        showAlertPrepaid(prepaidPrestations) {
            this.c_prepaidPrestations = [...prepaidPrestations]
        },

        unshowAlertPrepaid(prepaidPrestations) {
            this.c_prepaidPrestations = [...prepaidPrestations]
        },

        submit() {
            // console.log('promoCodesImpact', JSON.stringify(this.c_promoCodes))
            // // Log par item
            // for (const key in this.c_cartItems) {
            //     const item = this.c_cartItems[key]
            //     if (item.codePromo && item.codePromo.length > 0) {
            //         console.log(`item [${item.name}] promos:`, item.codePromo.map(p => ({
            //             itemKey: p.itemKey,
            //             code: p.code?.title,
            //             remise: p.remise,
            //             type: p.code?.discount_type,
            //             amount: p.code?.discount_amount,
            //         })))
            //     }
            // }
            this.$refs.form.submit()
        },

        redirect_userPayment(id) {
            this.iframePayment = true
            this.clientId = id
        },

        checkPromoBefore() {
            if (this.promoOrder) {
                this.promoOrder.forEach(element => {
                    this.promoCode = element.code
                    this.promoCodeEntered = element.code
                    this.checkPromoCode()
                })
            }
        },

        decrementRest(event) {
            const price = event.target.value

            this.cartRest = this.cartRest - price
            if (this.cartRest > 0) {
            }
        },

        // Set total price with voucher amount
        setTotalPrice(index, method) {
            // ✅ Utilise remainPrice (qui inclut déjà la déduction pending)
            // c_remainPrice est déjà mis à jour par remainPrice()
            const effectiveRemain = parseFloat(this.c_remainPrice)

            if (effectiveRemain > 0) {
                if (method.includes('cadeau')) {
                    if (this.voucherApplied) {
                        if (this.voucherTotal >= effectiveRemain) {
                            this.payments[index] = effectiveRemain
                        } else {
                            this.payments[index] = this.voucherTotal
                        }
                    }
                } else {
                    this.payments[index] = effectiveRemain
                }
                const tmp = this.payments
                this.payments = []
                this.payments = tmp
            }
        },

        addDiscountOnItem(rowId, price) {
            axios
                .post(`/back-office/caisse/${rowId}/addDiscount`, {
                    price: price,
                })
                .then(res => {
                    //
                })
        },
        addDiscountOnBasket(rowId, price) {
            axios
                .post(`/back-office/caisse/addDiscountBasket`, {
                    price: price,
                })
                .then(res => {
                    //
                })
        },
        getTotalWithDiscount() {
            var response = 0
            axios.get(`/back-office/caisse/getTotalWithDiscount`).then(res => {
                response = res.data
            })
            return response
        },
        getTotalWithoutDiscount() {
            axios.get(`/back-office/caisse/getTotalWithoutDiscount`).then(res => {
                response = res.data
            })
            return response
        },
        _computeAmountCodePromo(amount, currentCode) {
            let res = 0
            
            if (currentCode.discount_type == 'fixed') {
                res = currentCode.discount_amount
            } else if (currentCode.discount_type == 'percentage') {
                res = amount * (currentCode.discount_amount / 100)
            }
            return res
        },
        async getOrder(id) {
            return axios
                .get(`/back-office/get/order`, {
                    params: { id: id },
                })
                .then(res => {
                    this.c_order = res.data
                })
        },
        async getOrderByBookingId(id) {
            return axios
                .get(`/back-office/get/booking/order`, {
                    params: { id: id },
                })
                .then(res => {
                    this.c_order = res.data
                })
        },
    },
    //TODO: FIX les codes promo quand on rajoute des produit aux panier avec une prestation avec un accompte
    computed: {
        c_overlay: sync('overlay'),
        ...sync('overlay@data', {
            c_remainPrice: 'remainPrice',
            c_customer: 'customer',
            c_payments: 'payments',
            c_establishment: 'establishment',
            c_prepaidPrestations: 'prepaidPrestations',
            c_cartItems: 'cartItems',
            c_promoCodes: 'promoCodes',
            c_tmpPromoCodes: 'tmpPromoCodes',
            c_order: 'order',
            c_remainBeforeGlobalPromoCode: 'remainBeforeGlobalPromoCode',
            c_remainAfterGlobalPromoCode: 'remainAfterGlobalPromoCode',
            c_promoCodeNoCompleteUsed: 'promoCodeNoCompleteUsed',
        }),
        ...get('overlay@data', {
            c_customDiscount: 'customDiscount',
            c_prepaidPrestations: 'prepaidPrestations',
        }),
        
        pendingRemovalTotal() {
            if (!this.c_cartItems) return 0
            return Object.values(this.c_cartItems)
                .filter(item => item.pendingRemoval)
                .reduce((sum, item) => sum + (parseFloat(item.price) * parseInt(item.qty)), 0)
        },
            
        remainPrice() {
            let remainPlain = 0

            if (this.promoCodeApplied) {
                this.selectCode.push(this.promoCode)
                this.promoCodeApplied = false
            }

            let remain = 0.0
            let price = 0
            let price_product = 0
            this.totalAccompte = 0.0
            let price_product_base = 0

            // Abonnements et cures
            if (this.c_prepaidPrestations && this.c_payments) {
                // Reset les prépaiements déjà passés
                if (this.c_payments.findIndex(p => p.name == 'Abonnement') != -1) {
                    this.c_payments.splice(
                        this.c_payments.findIndex(p => p.name == 'Abonnement'),
                        1
                    )
                }
                if (this.c_payments.findIndex(p => p.name == 'Cure') != -1) {
                    this.c_payments.splice(
                        this.c_payments.findIndex(p => p.name == 'Cure'),
                        1
                    )
                }

                // Ajoute les prépaiements
                this.c_prepaidPrestations.forEach(item => {
                
                    if (item.prepaid.type == 'serie') {
                        if (this.c_payments.findIndex(p => p.name == 'Abonnement') != -1) {
                            this.c_payments.find(p => p.name == 'Abonnement').value += item.prestation.price / item.prestation.qty
                        } else {
                            this.c_payments.push({ name: 'Abonnement', value: item.prestation.price / item.prestation.qty })
                        }
                    } else if (item.prepaid.type == 'treatment') {
                        if (this.c_payments.findIndex(p => p.name == 'Cure') != -1) {
                            this.c_payments.find(p => p.name == 'Cure').value += item.prestation.price / item.prestation.qty
                        } else {
                            this.c_payments.push({ name: 'Cure', value: item.prestation.price / item.prestation.qty })
                        }
                    }
                })
            }

            this.c_promoCodeNoCompleteUsed = []
            // Parcours des produits du panier
            for (const key in this.c_cartItems) {
                // [Codes Promo]
                this.c_cartItems[key].codePromo = []


              

                if(this.c_cartItems[key].options.type=== 'App\\Models\\Voucher\\Voucher')
                {
                    let price = this.c_cartItems[key]._oldPrice


                    if(this.c_promoCodes&& this.c_cartItems[key]._oldPrice)
                    {
                  
                      this.c_promoCodes
                        .filter(x => x.has_voucher)
                        .forEach(code => {
                     
                            this.c_cartItems[key]._oldPrice = this.c_cartItems[key]._oldPrice
                            const computedPrice = this._computeAmountCodePromo(price, code)
 
                            const p = computedPrice > price ? price : computedPrice
                            this.c_cartItems[key].codePromo.push({ itemKey: key, code: code, remise: !code.has_voucher ? 0 : p })
                            price -=  !code.has_voucher ? 0 : p
                        })
                    this.c_cartItems[key].price = price < 0 ? 0.0 : price
                            
                    }

                   
                       

                }
                else
                {
                            if (this.c_cartItems[key].code && this.c_cartItems[key]._oldPrice) {
                                let price = this.c_cartItems[key]._oldPrice

                                this.c_cartItems[key].code
                                    .filter(x => !x.global || x.discount_type != 'fixed')
                                    .forEach(code => {
                                        const computedPrice = this._computeAmountCodePromo(price, code)
                                        const p = computedPrice > price ? price : computedPrice
                                        this.c_cartItems[key].codePromo.push({ itemKey: key, code: code, remise: !code.enable ? 0 : p })
                                        price -=  !code.enable ? 0 : p
                                    })
                                this.c_cartItems[key].price = price < 0 ? 0.0 : price


                }
                }

 
                 // [Codes Promo] "global fixed"
 
                if (this.c_cartItems[key].code && this.c_cartItems[key]._oldPrice) {
                    let price = this.c_cartItems[key].price

                    this.c_cartItems[key].code
                        .filter(x => x.enable && x.global && x.discount_type == 'fixed')
                        .forEach(code => {
                            const used = this.c_promoCodeNoCompleteUsed.reduce((prev, current) => {
                                if (current.codeId != code.id) return prev
                                return prev + current.used
                            }, 0)

                            const reduc = code.discount_amount - used
                            let tmp = {
                                itemKey: key,
                                remain: reduc - price < 0 ? 0 : reduc - price,
                                amount: reduc,
                                codeId: code.id,
                                used: 0,
                            }
                            tmp.used = tmp.amount - tmp.remain
                            this.c_cartItems[key].codePromo.push({ itemKey: key, code: code, remise: tmp.used })
                            this.c_promoCodeNoCompleteUsed.push(tmp)
                            price -= reduc
                        })
                    this.c_cartItems[key].price = price < 0 ? 0.0 : price
                }


               
                

                price = 0
                price_product = parseFloat(this.c_cartItems[key].price)*parseInt(this.c_cartItems[key].qty)
                price_product_base = parseFloat(this.c_cartItems[key].price)*parseInt(this.c_cartItems[key].qty)
 
                // Bon cadeau
                if (this.c_payments)
                    if (this.c_payments.filter(m => m.name == 'Bon cadeau').length > 0) {
                        this.c_payments[this.c_payments.findIndex(m => m.name == 'Bon cadeau')].value = this.voucherAmount
                    } else {
                        this.c_payments.push({ name: 'Bon cadeau', value: this.voucherAmount })
                    }

                if (price > 0) {
                    remain = parseFloat(remain) + parseFloat(price)
                } else {
                    remain += price_product
                }

            }

            // Avoir
            if (this.c_payments) {

                const indexCredit = this.c_payments.findIndex(m => m.name == 'Rbt Avoir')

                if (this.avoirAmount > 0) {

                    if (indexCredit !== -1) {
                        this.c_payments[indexCredit].value = this.avoirAmount
                    } else {
                        this.c_payments.push({ name: 'Rbt Avoir', value: this.avoirAmount })
                    }

                } else {
                    // Si montant = 0 → on supprime le paiement
                    if (indexCredit !== -1) {
                        this.c_payments.splice(indexCredit, 1)
                    }
                }
            }

            // Code promo (Global)
            this.c_remainBeforeGlobalPromoCode = remain
            this.c_remainAfterGlobalPromoCode = remain

            // if (this.c_order != null) {
            //     remain -= this.c_order.current_price
            //     remain -= this.c_order.fidelity_points
            //     remainPlain = remain
            // }

            if (this.c_order != null) {
                const invoices = this.c_order.invoices || []
                const isFidelityInvoice = inv => {
                    const methodName = (inv.payment_method?.name || '').toLowerCase()
                    return methodName.includes('fidélité') || inv.virtual_fidelity_points
                }
                const totalDeposits = invoices
                    .filter(inv => !isFidelityInvoice(inv))
                    .reduce((prev, inv) => prev + this.paymentAmountAppliedToOrder(inv), 0)
                const fidelityInvoiceTotal = invoices
                    .filter(isFidelityInvoice)
                    .reduce((prev, inv) => prev + parseFloat(inv.amount || 0), 0)
                const fidelityAmount = fidelityInvoiceTotal > 0
                    ? fidelityInvoiceTotal
                    : parseFloat(this.c_order.fidelity_points || 0)
                // ✅ Ajouter déduction des PrepaidReservations
                const totalPrepaidReserved = this.c_order.prepaid_reservations
                    ? this.c_order.prepaid_reservations
                        .filter(r => r.status === 'reserved')
                        .reduce((prev, r) => prev + parseFloat(r.amount_covered || 0), 0)
                    : 0

                remain -= totalDeposits           // DÉDUCTION DES ACOMPTES RÉELS
                remain -= totalPrepaidReserved           // DÉDUCTION DES ACOMPTES RÉELS
                remain -= fidelityAmount

                remainPlain = remain
            }

            if (this.c_payments) {
                remain =
                    remain -
                    this.c_payments.reduce((total, current) => parseFloat(total, 10) + parseFloat(current.value || 0, 10), 0)
                remainPlain = remain
            }

            if (this.usedFidelityPoints > 0) {
                remain -= this.usedFidelityPoints / this.establishment.points_for_one_euro
                remainPlain = remain
            }
            if (remainPlain && this.c_customDiscount && parseFloat(this.c_customDiscount))
                remainPlain -= parseFloat(this.c_customDiscount)

            remainPlain -= this.pendingRemovalTotal

            if (parseFloat(remainPlain) < 0.009) {
                this.c_remainPrice = parseFloat(remainPlain).toFixed(1)
                return parseFloat(remainPlain).toFixed(1)
            } else {
                this.c_remainPrice = parseFloat(remainPlain).toFixed(2)
                return parseFloat(remainPlain).toFixed(2)
            }
            
        },
    },
    watch: {
        serieSelected: {
            deep: true,
            handler: function(val) {
                this.serieSelected = val
            },
        },
        remainPrice() {
            //
        },
    },
}
</script>

<style></style>
